import { PortablePTag } from '@otovo/shared/components/Sanity/PortableTextComponents';
import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { Otovo$Locale } from '@otovo/shared/types/otovoweb';
import { Sanity$Banner } from '@otovo/shared/types/sanityTypes';
import cx from 'classnames';
import { useRouter } from 'next/router';
import { routeToHref } from '../../SanityLandingPage/routeToHrefUtil';
import CTALink from '../CTALink';
type BannerProps = {
  banner: Sanity$Banner;
  variant: 'default' | 'campaign';
};

const backgroundStyles: Record<BannerProps['variant'], string> = {
  default: 'bg-black/30',
  campaign: 'bg-peach-50',
};

const textStyles: Record<BannerProps['variant'], string> = {
  default: 'text-white',
  campaign: 'text-grey-80',
};

const Banner = ({ banner, variant }: BannerProps) => {
  const { cta, content } = banner;
  const config = useGlobalConfig();
  const { locale } = useRouter() as { locale: Otovo$Locale };
  const textClasses = textStyles[variant];

  return (
    <div
      className={cx(
        'color-scheme-dark absolute top-20 z-40 flex w-full flex-col px-4 py-3 sm:flex-row sm:items-center sm:justify-center sm:gap-2 sm:px-6 sm:py-2',
        backgroundStyles[variant],
        textClasses,
      )}
    >
      <PortablePTag
        value={content}
        className="inline-block text-sm font-medium sm:text-base"
      />
      {cta && (
        <CTALink
          className={cx(
            'underline underline-offset-4 hover:!no-underline',
            textClasses,
          )}
          href={routeToHref(cta.route, config.BU_CONFIG.market, locale)}
        >
          {cta.title}
        </CTALink>
      )}
    </div>
  );
};
export default Banner;
